// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"f6a3482a","156":"0a4864af","165":"db1b89d3"}[chunkId] + ".css";
};